import { alereAxios } from '../utils/api';

export const getSubsidiary = () => alereAxios.get('subsidiaries');
